import * as React from "react"

import styled from "styled-components"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconShakacode = ({
  title = "Add Photo",
  viewBoxWidth = 206,
  viewBoxHeight = 47,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="b-shaka">
        <stop stopColor="#F32B05" offset="0%" />
        <stop stopColor="#B00012" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="24.608%" x2="50%" y2="72.622%" id="c-shaka">
        <stop stopColor="#FF6956" offset=".792%" />
        <stop stopColor="#FF6956" stopOpacity=".01" offset="96.579%" />
      </linearGradient>
      <path
        d="M11.207 10h41.586a2 2 0 011.77 1.069l8.702 16.534a2 2 0 01-.453 2.437L33.317 55.848a2 2 0 01-2.634 0L1.188 30.04a2 2 0 01-.453-2.437l8.703-16.534A2 2 0 0111.208 10z"
        id="a-shaka"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <text
        fontFamily="Montserrat-Bold, Montserrat"
        fontSize="20"
        fontWeight="bold"
        fill="#333738"
        transform="translate(0 -10)"
      >
        <tspan x="80" y="41">
          ShakaCode
        </tspan>
      </text>
      <g transform="translate(0 -10)">
        <path d="M0 0h64v64H0z" />
        <mask id="d-shaka" fill="#fff">
          <use xlinkHref="#a-shaka" />
        </mask>
        <use fill="url(#b-shaka)" xlinkHref="#a-shaka" />
        <path
          d="M7 43c22.118-2.144 33.57-6.578 34.354-13.303 1.178-10.088-17.4-1.454-20.927-1 9.658-7.17 22.018-11.721 37.08-13.652H66V57H7V43z"
          fill="url(#c-shaka)"
          mask="url(#d-shaka)"
        />
      </g>
    </g>
  </Svg.Icon>
)

export const HeaderIconShakacode = styled(IconShakacode)`
  height: 64px;
  width: 199px;
`

export const FooterIconShakacode = styled(IconShakacode)`
  height: 48px;
  width: 149px;
`
